import { type ClassValue, clsx } from "clsx";
import { Signal, SignalHigh, SignalLow, SignalMedium, SignalZero } from "lucide-react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function classNames(...classes: any) {
    return classes.filter(Boolean).join(" ");
}

export function isEmail(email) {
    // A common regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const types = [
    { id: 5, name: "Incident" },
    { id: 1, name: "Service" },
    { id: 2, name: "Feature" },
    { id: 3, name: "Bug" },
    { id: 4, name: "Maintenance" },
    { id: 6, name: "Access" },
    { id: 8, name: "Feedback" },
];

export const priorities = [
    {
        id: "low",
        name: "Low",
        icon: SignalZero,
        color: "gray",
        badge: "bg-gray-100 text-gray-800"
    },
    {
        id: "normal",
        name: "Normal",
        icon: SignalLow,
        color: "lime",
        badge: "bg-lime-100 text-lime-800"
    },
    {
        id: "medium",
        name: "Medium",
        icon: SignalMedium,
        color: "yellow",
        badge: "bg-yellow-100 text-yellow-800"
    },
    { id: "high", name: "High", icon: SignalHigh, color: "orange", badge: "bg-orange-100 text-orange-800" },
    { id: "critical", name: "Critical", icon: Signal, color: "red", badge: "bg-red-100 text-red-800" },
];
